
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  private window: any = window;
  private get user() {
    return this.$store.state.user;
  }
  /**
   * @description 点击切换账号
   */
  private handleCommand(command: any) {
    if (command === "退出登录") {
      localStorage.setItem("accountFilter", "");
      this.$store.commit("updateToken", "");
      this.$router.push("/login");
      location.reload();
    }
  }
}
